import { SxProps, Theme } from '@mui/material';
import { UseTreeItemStatus } from '@mui/x-tree-view';

export const childNodeClassName = 'childnode';

export const navTreeLabelStyling =
  (isChildNode: boolean): SxProps<Theme> =>
  (theme) => ({
    color: isChildNode ? 'text.secondary' : undefined,
    fontSize: '14px',
    padding: theme.spacing(0.5, 0),
    fontWeight: 'medium',
  });

export const navTreeContentStyling = (
  depth: number,
  status: UseTreeItemStatus
): SxProps<Theme> => ({
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: depth > 2 ? 1 : depth > 1 ? 3 : depth > 0 ? 2 : 0,
  backgroundColor: status.selected ? 'background.paper' : undefined,
  fontWeight: status.selected ? 600 : undefined,

  '> *': (theme) => ({
    fontWeight: status.selected ? 600 : undefined,
    color: status.selected ? 'primary.main' : undefined,
    ...theme.applyStyles('dark', { color: status.selected ? 'primary.light' : undefined }),
  }),
});

export const navTreeGroupTransition: SxProps<Theme> = () => ({
  padding: 0,
});
